<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-form class="mb-3" @submit.prevent="fetchContacts">
          <b-input-group>
            <b-form-input type="search" :placeholder="$t('search')" v-model="searchText" minlength="2" maxlength="150" @keyup.enter="fetchContacts"/>
            <b-input-group-append>
              <b-button type="submit" variant="outline-primary">
                <b-icon icon="search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
        <div class="select-button-group">
          <b-button  @click="onClickSelectAll" variant="outline-primary" style="margin-right: 5px;">
          {{ $t("selectAll") }}
        </b-button>
        <b-button @click="onClickdeselectAll" variant="outline-primary">
          {{ $t("deselectAll") }}
        </b-button>
        </div>
        <div class="py-3 text-center" v-if="isLoading">
          <b-spinner />
        </div>
        
        <b-list-group v-else class="contacts-list-group">
          <div v-if="!displaySearchContacts.length" class="py-3 text-center text-secondary">
            {{ $t("noData") }}
          </div>
          <b-list-group-item v-for="contact in displaySearchContacts" :key="contact.id" button @click="onClickAddContact(contact)">
            <div class="d-flex flex-row align-items-center">
              <div class="flex-grow-1">
                <div>{{ contact.name }}</div>
                <!-- <div><small class="text-secondary">{{ contact.subtitleText }}</small></div> -->
                <b-row class="small">
                  <b-col cols="7">
                    <b-icon class="mr-1" icon="envelope"/>{{ contact.email }} 
                    <br/>
                    <span v-if="contact.organization">
                      <b-icon class="mr-1" icon="building"></b-icon>
                      {{ contact.organization }}
                    </span>
                  </b-col>
                  <b-col cols="5" v-if="contact.phone">
                    <b-icon class="mr-1" icon="telephone"/> {{ contact.phone }}
                  </b-col>
                  <b-col cols="7" v-if="contact.code && onFaceidForMeeting">
                    <span class="mr-1">Code:</span> {{ contact.code }}
                  </b-col>
                  <b-col cols="5" v-if="contact.code && onFaceidForMeeting">
                    <span class="mr-1">{{$t('status')}}:</span> {{ contact.imgUploadStatus }}
                  </b-col>
                </b-row>
              </div>
              <div class="flex-shrink-0">
                <span class="text-primary"><b-icon-plus-circle /></span>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col cols="6">
        <div style="height: 38px;" class="mb-3">
          <h5>{{ $t("selecting", { count: selectedContacts.length}) }}</h5>
        </div>
        <b-list-group class="contacts-list-group">
          <div v-if="!selectedContacts.length" class="py-3 text-center text-secondary">
            {{ $t("noData") }}
          </div>
          <b-list-group-item v-for="(contact, i) in selectedContacts" :key="contact.id" button @click="onClickRemoveContact(i)">
            <div class="d-flex flex-row align-items-center">
              <div class="flex-grow-1">
                <div>{{ contact.name }}</div>
                <!-- <div><small class="text-secondary">{{ contact.subtitleText }}</small></div> -->
                <b-row class="small">
                  <b-col cols="7">
                    <b-icon class="mr-1" icon="envelope"/>{{ contact.email }}
                    <br/>
                    <span v-if="contact.organization">
                      <b-icon class="mr-1" icon="building"/>
                      {{ contact.organization }}
                    </span>
                  </b-col>
                  <b-col cols="5" v-if="contact.phone">
                    <b-icon class="mr-1" icon="telephone"/> {{ contact.phone }}
                  </b-col>
                  <b-col cols="7" v-if="contact.code && onFaceidForMeeting">
                    <span class="mr-1">Code:</span> {{ contact.code }}
                  </b-col>
                  <b-col cols="5" v-if="contact.code && onFaceidForMeeting">
                    <span class="mr-1">{{$t('status')}}:</span> {{ contact.imgUploadStatus }}
                  </b-col>
                </b-row>
              </div>
              <div class="flex-shrink-0">
                <span class="text-primary"><b-icon-dash-circle /></span>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <div class="text-right border-top pt-2">
      <b-button variant="secondary" class="mr-3" @click="onClickCancel">{{ $t("cancel") }}</b-button>
      <b-button variant="primary" @click="done">{{ $t("ok") }}</b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .contacts-list-group {
    max-height: calc(100vh - 280px);
    overflow-y: scroll;
  }
  .select-button-group{
    margin: 5px 0px;
    display: flex;
    justify-content: flex-start;
  }
</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _, { clone } from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as contactService from "@/service/contactService";
  import * as util from "@/service/util";

  @Component
  export default class PickMultipleContactModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) p_selectedContacts: any[];
    @Prop({ required: true }) onFaceidForMeeting: boolean;
    
    isLoading = false;

    searchText = "";
    searchContacts = [];
    selectedContacts = [];

    pageSize = 10000;

    get displaySearchContacts() {
      return this.searchContacts.filter(contact => this.selectedContacts.every(selectedContact => selectedContact.id !== contact.id && selectedContact.contactId !== contact.id));
    }

    created() {
      this.selectedContacts = util.jsonClone(this.p_selectedContacts);
      
      while (this.pageSize < this.selectedContacts.length + 30) {
        this.pageSize *= 2;
      }
      if (this.pageSize > 10000) this.pageSize = 10000;
    }

    mounted() {
      this.fetchContacts();
    }

    async fetchContacts() {
      try {
        this.isLoading = true;
        const pageSize = this.searchText?.trim() ? 10000 : this.pageSize;
        this.searchContacts = (await contactService.getAllContacts(1, pageSize, this.searchText?.trim())).data;

        // for (const c of this.searchContacts) {
        //   c.subtitleText = [c.title, c.department, c.organization].map(it => it?.trim()).filter(_.identity).join(" - ");
        // }
        // for(const select of this.selectedContacts) {
        //   select.subtitleText = this.searchContacts.find(sc => sc.id == select.contactId || sc.id == select.id).subtitleText;         
        // }

      } catch (e) {
        this.toastError(e);
      } finally {
        this.isLoading = false;
      }
    }

    async onClickSelectAll() {
     this.selectedContacts = clone(this.searchContacts);
     this.checkFaceIdBeforeSelectAll();
      return;
    }
    checkFaceIdBeforeSelectAll() {
      if(this.onFaceidForMeeting) {
       this.selectedContacts.forEach(contact => {
      
       });
       this.selectedContacts = this.selectedContacts.filter(contact => contact.imgUploadStatus == "SUCCESS");
      }
    }

    onClickdeselectAll() {
      this.selectedContacts = [];
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    @Emit()
    done() {
      this.$bvModal.hide(this.modalId);
      return this.selectedContacts;
    }

    async onClickAddContact(contact) {      
      if(this.onFaceidForMeeting) {
        if(contact.imgUploadStatus != "SUCCESS") {
          this.toastError({ code: "faceid_not_verified" });
          return;
        }
      }
      this.selectedContacts.push(contact);
      if (this.displaySearchContacts.length < 30 && !this.searchText?.trim()) {
        this.pageSize *= 2;
        if (this.pageSize > 10000) this.pageSize = 10000;
        try {
          this.searchContacts = (await contactService.getAllContacts(1, this.pageSize, this.searchText?.trim())).data;

          // for (const c of this.searchContacts) {
          //   c.subtitleText = [c.title, c.department, c.organization].map(it => it?.trim()).filter(_.identity).join(" - ");
          // }

        } catch (e) {
          this.toastError(e);
        }
      }
    }

    onClickRemoveContact(index: number) {
      this.selectedContacts.splice(index, 1);
    }

  }
</script>
